import * as documentActionType from './documentActionType';

const initialDocumentState = {
  document_data: [],
  fields_for_document: {},
  update_fields_for_document: [],
};

const documentReducer = (state = initialDocumentState, { type, payload }) => {
  switch (type) {
    case documentActionType.DOCUMENT_DATA:
      return {
        ...state,
        document_data: payload,
      };
    case documentActionType.ADD_DOCUMENT:
      return {
        ...state,
        add_document: payload,
      };
    case documentActionType.DOCUMENT_DASHBOARD_LENGTH:
      return {
        ...state,
        document_length: payload,
      };
    case documentActionType.GET_FIELDS_FOR_DOCUMENT:
      return {
        ...state,
        fields_for_document: payload,
      };
    case documentActionType.SET_UPDATE_FIELDS_FOR_DOCUMENT:
      return {
        ...state,
        update_fields_for_document: payload,
      };

    default:
      return state;
  }
};

export default documentReducer;
